import React from 'react'
import OwlCarousel from 'react-owl-carousel'
import 'owl.carousel/dist/assets/owl.carousel.css'
import 'owl.carousel/dist/assets/owl.theme.default.css'
import { TwitterEmbed } from 'react-social-media-embed';


const options = {
  // margin: 4,
  responsiveClass: true,
  nav: false,
  dots: false,
  autoplay: true,
  smartSpeed: 1000,
  loop: true,
  responsive: {
    0: {
      items: 1,
    },

    600: {
      items: 1,
    },

    1000: {
      items: 1,
    },
  },
}
function TwitterFeeds() {
  return (
    <div id="reports-on-torture">
      <div className="gallery" data-aos="fade-up">
        <div className="container py-5">
          <OwlCarousel {...options}>
            <div>
            <TwitterEmbed url="https://twitter.com/JusticeProject_/status/1540639557141553158?t=zy8XsDwXRxr57HtdP63b3A&s=19" width={300} height={300} />
            </div>

            <div>
            <TwitterEmbed url="https://twitter.com/JusticeProject_/status/1540639557141553158?t=zy8XsDwXRxr57HtdP63b3A&s=19" width={300} height={300} />
            </div>
            <div>
            <TwitterEmbed url="https://twitter.com/JusticeProject_/status/1540639557141553158?t=zy8XsDwXRxr57HtdP63b3A&s=19" width={300} height={300} />
            </div>
          </OwlCarousel>
        </div>
      </div>
    </div>
  )
}

export default TwitterFeeds
